"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CustomerJourneyPhase;
(function (CustomerJourneyPhase) {
    CustomerJourneyPhase["NEW_CUSTOMER"] = "new_customer";
    CustomerJourneyPhase["OTHER"] = "other";
    CustomerJourneyPhase["FIXED"] = "fixed";
    CustomerJourneyPhase["RENEWABLE"] = "renewable";
    CustomerJourneyPhase["VARIABLE"] = "variable";
})(CustomerJourneyPhase || (CustomerJourneyPhase = {}));
exports.default = CustomerJourneyPhase;
